<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="mx-auto col-lg-12 col-12">
        <div class="mt-4 card card-body">
          <Form 
          titlePage="Detail User"
          subtitlePage="Detail a User"
          submitButtonName="Update User"
          :onSubmit="onSubmit"
          :onUpdateActivation="onUpdateActivation"
          :recordProps="record" 
          @cancel="goBack"
          />

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "./Form.vue";
import UsersService from "@/services/users.service.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const toastId = ref('');


export default {
  name: "ExternalUserEdit",
  components: {
    Form
  },

  data() {
    return {
      record: {},
    };
  },
  mounted(){
    this.getRecord()
  },
  methods: {
    showLoading(){
      toastId.value = toast.loading('Please wait...');
    },
    hideLoading(){
      setTimeout(() => {
        toast.remove(toastId.value)
      }, 1000); 
    },
    showSuccess(){
      toast.update(toastId.value, {
        render: "Update Successfully",
        closeOnClick: true,
        closeButton: true,
        type: 'success',
        isLoading: false,
        autoClose: 3000
      });
      
      setTimeout(() => {
        this.goBack()
      }, 1000);     
    },
    showFailed(e){
      toast.update(toastId.value, {
        render: e,
        closeOnClick: true,
        closeButton: true,
        type: 'error',
        isLoading: false,
        autoClose: 3000
      });
    },
    onSubmit(data){
      this.showLoading()
      
      UsersService.update(data, this.$route.params.id).then(() => {
        this.showSuccess()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });

    },
    onUpdateActivation(isActive){
      this.showLoading()
      
      UsersService.update({ is_active: isActive }, this.$route.params.id).then(() => {
        this.showSuccess()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });
    },

    getRecord(){
      this.showLoading()
      
      UsersService.get(this.$route.params.id, this.$route.query.by_email).then(e => {
        this.record = e.data.registration_data
        this.record.password = ''
        this.hideLoading()
      }).catch(e => {
        this.showFailed(e.response.data.code_message)           
      });
    },
    goBack(){
      this.$router.push({
        path: '/external-users',
        query: this.$route.query
      })
    }
  }
};
</script>
